module.exports = __webpack_public_path__ + "img/client.eb926015.jpg";